__webpack_require__.p = "/zadanie-3/";